import { useQueryClient } from "@tanstack/react-query";

import { useDatasets } from "src/datasets/api/queries";
import { useAuthoringContext } from "src/router/routerContextHooks";
import {
  useCopilotContextualEntities,
  useCopilotRefetchOnMutation,
} from "src/unifiedCopilot/context/hooks";
import type { ReferenceContextualEntity } from "src/unifiedCopilot/context/types";

export const useFlowVersionCopilotContext = (): void => {
  const { flow, version, workspace } = useAuthoringContext();
  const queryClient = useQueryClient();
  const { data: datasets = [] } = useDatasets({
    flowId: flow.id,
    baseUrl: workspace.base_url,
  });

  useCopilotContextualEntities(
    [
      {
        kind: "reference",
        type: "flow",
        id: flow.id,
        displayName: flow.name,
      },
      {
        kind: "reference",
        type: "flow-version",
        id: version.id,
        displayName: version.name,
        parent: {
          type: "flow",
          id: flow.id,
        },
      },
    ],
    { includeInAgentContext: true },
  );

  const datasetEntities: ReferenceContextualEntity[] = datasets.map(
    (dataset) => ({
      kind: "reference",
      type: "dataset",
      id: dataset.id,
      displayName: dataset.name,
      parent: {
        type: "flow",
        id: flow.id,
      },
    }),
  );
  useCopilotContextualEntities(datasetEntities);

  useCopilotRefetchOnMutation(() =>
    queryClient.invalidateQueries({
      queryKey: ["datasets", workspace.base_url, flow.id],
      exact: true,
    }),
  );
};
